import { useAtom } from 'jotai';
import React, { FunctionComponent } from 'react';

import { Box, Button } from '@mui/material';

import {
  currentPageIndexAtom,
  isInitializingAtom,
  locationsAtom,
  selectedLocationIdAtom,
  selectedRefinerItemsAtom,
  selectedSitesAtom,
  startRowAtom,
} from '../utils/AtomConfig';

export const Location: FunctionComponent = () => {
  const [locations] = useAtom(locationsAtom);
  const [, setIsInitializing] = useAtom(isInitializingAtom);
  const [, setCurrentPageIndex] = useAtom(currentPageIndexAtom);
  const [, setStartRow] = useAtom(startRowAtom);
  const [, setSelectedSites] = useAtom(selectedSitesAtom);
  const [, setSelectedRefinerItems] = useAtom(selectedRefinerItemsAtom);
  const [selectedLocationId, setSelectedLocationId] = useAtom(
    selectedLocationIdAtom
  );

  function onLocationChange(id: number, title: string) {
    // Reset all data
    setIsInitializing(true);
    setCurrentPageIndex(1);
    setStartRow(0);
    setSelectedLocationId(id);
    setSelectedSites([]);
    setSelectedRefinerItems([]);
  }

  function isLocationSelected(locationId: number) {
    return selectedLocationId === locationId;
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      {locations.map((location) => (
        <Button
          key={location.id}
          variant='text'
          onClick={() => onLocationChange(location.id, location.title)}
          sx={{
            color: 'white',
            marginLeft: '20px',
            boxShadow: 'none',
            height: '62px',
            borderRadius: 0,
            backgroundColor: isLocationSelected(location.id)
              ? 'rgba(0,0,0,0.4)'
              : 'rgba(0,0,0,0)',
            ':hover': {
              backgroundColor: 'rgba(0,0,0,0.2)'
            },
          }}
        >
          {location.title}
        </Button>
      ))}
    </Box>
  );
};
